<template>
  <div>
    <!-- 头部 -->
    <el-card class="header-card">
      <div class="login-header flex between items-center">
        <div class="flex">
          <div class="logo pointer flex items-center">
            <img src="../assets/images/logo.png" alt="" style="width: 100%" />
          </div>
          <h1>欢迎登录</h1>
        </div>
        <div class="back pointer" @click="goIndex">返回首页</div>
      </div>
    </el-card>

    <!-- 中间内容 -->
    <div class="content-box">
      <el-card class="login-box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="会员登录" name="first">
            <el-form
              :model="loginForm"
              :rules="loginFormRules"
              ref="loginFormRef"
            >
              <el-form-item prop="userName">
                <el-input
                  @blur="inputBlur"
                  v-model="loginForm.userName"
                  placeholder="请输入用户名"
                  class="input-with-select"
                >
                  <template slot="prepend">
                    <div>
                      <img src="../assets/images/me.png" alt="" />
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  @input="inputBlur"
                  v-model="loginForm.password"
                  placeholder="请输入密码"
                  type="password"
                  class="input-with-select"
                >
                  <template slot="prepend">
                    <div>
                      <img src="../assets/images/pwd.png" alt="" />
                    </div>
                  </template>
                </el-input>
              </el-form-item>

              <el-form-item class="pwd-register">
                <div class="flex between items-center">
                  <span class="pointer set-pwd size14" @click="goRestPwd"
                    >忘记密码</span
                  >

                  <span class="pointer size14 register" @click="register"
                    >立即注册</span
                  >
                </div>
              </el-form-item>

              <el-form-item>
                <el-button
                  @click="loginBtn"
                  :disabled="isLogin"
                  type="primary"
                  class="w100"
                  >登录</el-button
                >
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="动态密码登录" name="second">
            <el-form
              :model="codeLogin"
              :rules="codeLoginRules"
              ref="codeLoginRef"
            >
              <el-form-item prop="phone">
                <el-input
                  @blur="phoneBlue"
                  v-model="codeLogin.phone"
                  placeholder="请输入手机号"
                  class="input-with-select"
                >
                  <template slot="prepend">
                    <div>
                      <img src="../assets/images/phone.png" alt="" />
                    </div>
                  </template>
                </el-input>
              </el-form-item>
              <!-- <el-form-item>
                <div class="flex between items-center">
                  <el-input
                    style="width: 160px"
                    placeholder="请输入验证码"
                    class="input-with-select"
                  >
                    <template slot="prepend">
                      <div>
                        <img src="../assets/images/key.png" alt="" />
                      </div>
                    </template>
                  </el-input>
                  <img
                    src=""
                    alt=""
                    style="border: 1px solid gray; width: 100px; height: 26px"
                  />
                  <div>
                    <div class="size12 text">看不清</div>
                    <div class="text1 size12">换一换</div>
                  </div>
                </div>
              </el-form-item> -->
              <el-form-item prop="code">
                <div class="flex between items-center">
                  <el-input
                    @input="phoneBlue"
                    v-model="codeLogin.code"
                    style="width: 232px"
                    placeholder="请输入短信动态码"
                    class="input-with-select"
                  >
                    <template slot="prepend">
                      <div>
                        <img src="../assets/images/code.png" alt="" />
                      </div>
                    </template>
                  </el-input>
                  <div class="code pointer" v-if="isCode" @click="getCode">
                    发送验证码
                  </div>
                  <div class="code pointer" v-else>{{ ms }}秒后获取</div>
                </div>
              </el-form-item>

              <el-form-item>
                <el-button
                  @click="codeLoginBtn"
                  :disabled="isLogin1"
                  type="primary"
                  class="w100"
                  >登录</el-button
                >
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>
    <Footer />
    <Result
      :title="title"
      :SubTitle="subTitle"
      :isShow="isShow"
      @change="resultClose"
    />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Result from "@/components/Result";

export default {
  components: {
    Footer,
    Result,
  },
  data() {
    return {
      title: "登录失败",
      subTitle: "用户名或密码错误",
      isShow: false,
      isCode: true,
      ms: 59,
      activeName: "first",
      isLogin: true,
      isLogin1: true,
      loginForm: {
        userName: null,
        password: null,
      },
      loginFormRules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      codeLogin: {
        phone: null,
        code: null,
      },
      codeLoginRules: {
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  methods: {
    resultClose() {
      this.isShow = false;
    },
    //获取验证码
    async getCode() {
      if (!this.codeLogin.phone) {
        this.title = "获取失败";
        this.subTitle = "请输入手机号";
        this.isShow = true;
        return;
      }
      //请求验证码
      const { data: res } = await this.$axios.get("/api/verifyCode/getCode", {
        params: {
          type: 1,
          phone: this.codeLogin.phone,
        },
      });
      if (res.code == 200) {
        this.title = "验证码发送成功";
        this.subTitle = "";
        this.isShow = true;
        this.isCode = false;
        let timer = null;
        timer = setInterval(() => {
          if (this.ms > 0) {
            --this.ms;
          } else {
            this.isCode = true;
            this.ms = 59;

            clearInterval(timer);
          }
        }, 1000);
      } else {
        this.title = "获取失败";
        this.subTitle = res.msg;
        this.isShow = true;
      }
    },
    //登录按钮
    loginBtn() {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        const { data: res } = await this.$axios({
          url: "/api/userInfo/userLoginByUserName",
          params: this.loginForm,
          method: "post",
        });
        console.log(res);

        if (res.code == "200") {
          this.title = "登录成功";
          this.subTitle = "";
          this.isShow = true;
          window.sessionStorage.setItem("token", res.data.token);
          window.sessionStorage.setItem("userId", res.data.user.id);
          window.sessionStorage.setItem("loginName", res.data.user.loginName);
          window.sessionStorage.setItem("phone", res.data.user.phone);
          window.sessionStorage.setItem("authId", res.data.user.authId);
          window.sessionStorage.setItem(
            "supplierId",
            res.data.user.authSupplierId
          );
          window.sessionStorage.setItem(
            "supplierName",
            res.data.user.supplierName
          );
          this.$router.push("/");
          // this.$router.go(-1);
        } else {
          this.title = "登录失败";
          this.subTitle = res.msg;
          this.isShow = true;
        }
      });
    },
    codeLoginBtn() {
      this.$refs.codeLoginRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        const { data: res } = await this.$axios({
          url: "/api/userInfo/userLoginByPhone",
          params: this.codeLogin,
          method: "post",
        });
        if (res.code == "200") {
          this.$message.success(res.msg);
          window.sessionStorage.setItem("token", res.data.token);
          window.sessionStorage.setItem("userId", res.data.user.id);
          window.sessionStorage.setItem("loginName", res.data.user.loginName);
          window.sessionStorage.setItem("phone", res.data.user.phone);
          window.sessionStorage.setItem("authId", res.data.user.authId);
          window.sessionStorage.setItem(
            "supplierId",
            res.data.user.authSupplierId
          );
          window.sessionStorage.setItem(
            "supplierName",
            res.data.user.supplierName
          );
          this.$router.go(-1);
        } else {
          this.title = "登录失败";
          this.subTitle = res.msg;
          this.isShow = true;
        }
      });
    },
    //用户名和密码框是去焦点
    inputBlur() {
      if (this.loginForm.userName && this.loginForm.password) {
        this.isLogin = false;
      }
    },
    phoneBlue() {
      if (this.codeLogin.phone && this.codeLogin.code) {
        this.isLogin1 = false;
      }
    },
    handleClick() {},
    //点击注册
    register() {
      this.$router.push("/register");
    },
    //点击返回首页
    goIndex() {
      this.$router.push("/");
    },
    //点击跳转忘记密码
    goRestPwd() {
      this.$router.push("resetpwd");
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-card {
  border: none !important;
}
/deep/.el-card__body {
  padding: 0 !important;
}
/deep/.header-card.el-card.is-always-shadow {
  box-shadow: 0px 3px 6px rgb(204 217 233 / 70%);
}
// 头部
.header-card {
  position: relative;
  z-index: 100;
}
.login-header {
  width: 1200px;
  height: 84px;
  margin: 0 auto;
  .logo {
    width: 330px;
    // background-color: #1c65c4;
    color: #fff;
    text-align: center;
    line-height: 84px;
    height: 84px;
  }
  h1 {
    line-height: 84px;
    font-size: 36px;
    margin-left: 50px;
  }
  .back {
    width: 122px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #1c65c4;
    color: #1c65c4;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
  }
}
// 内容
.content-box {
  height: 640px;
  background: url("../assets/images/ditu.png") no-repeat;
  position: relative;
  .login-box {
    width: 410px;
    height: 415px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    padding-left: 45px;
    padding-right: 45px;
    padding-top: 50px;
    .set-pwd {
      color: #95b3db;
    }
    .register {
      color: #3b426b;
    }
    .text {
      color: #ccd9e9;
      line-height: 14px;
    }
    .text1 {
      color: #3b426b;
      line-height: 14px;
    }
    .code {
      font-size: 14px;
      color: #3b426b;
    }
  }
  /deep/.login-box.el-card.is-always-shadow {
    box-shadow: 0px 0px 15px rgba(28, 101, 196, 0.3);
  }
  /deep/.el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
    background-color: #e4e7ed;
    z-index: 1;
  }
  /deep/.el-tabs__active-bar {
    width: 16px !important;
    // transform: translateX(100%) !important;
    margin-left: 30px;
    background-color: #1c65c4;
  }
  /deep/.el-tabs__item.is-active {
    color: #02224b;
  }
  /deep/.el-tabs__item {
    color: #ccd9e9;
    font-size: 18px;
  }
  /deep/.el-input-group__prepend {
    background-color: #ccd9e9;
    padding: 0 12px;
    padding-top: 6px;
  }
  /deep/.el-input__inner {
    background-color: #f7f9fc;
    border: none;
    font-size: 14px;
    // color: #ccd9e9;
  }
  /deep/.pwd-register.el-form-item {
    margin-bottom: 0px;
  }
  /deep/.el-button--primary.is-disabled {
    background-color: #1c65c4;
    opacity: 0.5;
  }
  /deep/.el-button--primary {
    background-color: #1c65c4;
  }
}
</style>